module.exports = __webpack_public_path__ + "static/media/company-logo-7.5840cb3f.png";